export default {
	init() {
		// JavaScript to be fired on all pages
	},
	finalize() {
		$('.room__rate--listing').append('<div class="clearfix"></div>');
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js